import {isNaN, split} from 'lodash';
import {AccountStatus, User} from "../redux/entities/user";
import {format, utcToZonedTime} from "date-fns-tz";
import {parseISO} from "date-fns";
import React from "react";

export const now = new Date();

export const localTz = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const localTzFriendlyFormat = localTz.replace('_', ' ');

const getTimezoneFromDate = (dateAsString: string) => dateAsString.match(/\(([^\)]+)\)$/)![1];

export const splitHTMLTimeInput = (militaryTime: string) => {
  return split(militaryTime, ':', 2).map((i) => {
    const int = parseInt(i, 10);
    if (isNaN(int)) {
      throw new Error('TimeNaN');
    }
    return int;
  });
};

export const setDateHoursAndMinutes = (date: Date, time: string) => {
  const parts = (time as any).split(':');
  date.setHours(parts[0]);
  date.setMinutes(parts[1]);
  return date;
};

export function seconds(numSeconds: number) {
  return numSeconds * 1000;
}

export const dateTimeFormatter = (isoDateTime: string) => {
  const formatDate = (isoDate: string) =>
    format(utcToZonedTime(parseISO(isoDate), localTz as any as string), 'MM/dd/yyyy hh:mm:ss a', {timeZone: localTz as any as string});
  return (
    <div style={{display: 'flex', justifyContent: 'flex-start'}}>
      {`${formatDate(isoDateTime)}`}
    </div>
  );
};
